import { faCartPlus } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Grid from '@mui/material/Grid'
import { useEffect, useState } from 'react'
import { confirmAlert } from 'react-confirm-alert'
import { useDispatch, useSelector } from 'react-redux'
import Select from 'react-select'
import { getStockArtAlu } from '../../../actions/articulo'
import { getMasGrupos, unsetExGrupoSeleccionado } from '../../../actions/extrusion/ExGrupos'
import { getMasPerfiles, unsetPerfilSeleccionado } from '../../../actions/extrusion/ExPerfiles'
import { getMasSeries, unsetExSerieSeleccionada } from '../../../actions/extrusion/ExSeries'
import { unsetExSubSerieSeleccionada } from '../../../actions/extrusion/ExSubSeries'
import {
  getTratamientosDisponibles,
  setListaTiposTratamiento2,
  setListaTratamientos1Completa,
  setListaTratamientos2,
  setListaTratamientos2Completa,
  setListaValoresEmpaquetado,
  setListaValoresTratamiento2,
  setTiposTratamiento1,
  setTratamientos1,
  unsetListaEmpaquetado,
  unsetListasTratamientos,
  unsetTratamientos1,
  unsetTratamientos1Completa,
  unsetTratamientos2,
} from '../../../actions/extrusion/ExTratamientos'
import { unsetBusquedaExtrusion } from '../../../actions/extrusion/buscadorExtrusion'
import { postLinea } from '../../../actions/pedidos'
import { getPrecio } from '../../../actions/precios'
import { cargarParametros } from '../../../helpers/funciones'
import { retrieveDefaultPresentation } from '../../../helpers/presentations'
import i18n from '../../../lang/idiomas'
import Spinner from '../../layout/Spinner'
import Precio from '../Precio'
import TablaStock from './TablaStock'

let parametros,
  parametros_usados = [
    'mostrar_peso_teorico',
    'mostrar_superficie_total',
    'presentacion_stock',
    'mostrar_iva',
  ]

const FormularioExtrusion = () => {
  const dispatch = useDispatch()

  const portal = useSelector(state => state.portal.portal)
  const perfiles = useSelector(state => state.experfiles.perfiles)
  const perfil_seleccionado = useSelector(state => state.experfiles.perfil_seleccionado)
  const recuperando_datos = useSelector(state => state.extratamientos.isLoading)
  const lista_longitudes = useSelector(state => state.extratamientos.lista_longitudes)
  const lista_tratamientos_disponibles = useSelector(
    state => state.extratamientos.lista_tratamientos_disponibles,
  )
  const lista_tratamientos_1_completa = useSelector(
    state => state.extratamientos.lista_tratamientos_1_completa,
  )
  //const lista_tipos = useSelector(state => state.extratamientos.lista_tipos)
  const lista_tratamientos_1 = useSelector(state => state.extratamientos.lista_tratamientos_1)
  const lista_tratamientos_2 = useSelector(state => state.extratamientos.lista_tratamientos_2)
  const lista_valores_tratamiento_2 = useSelector(
    state => state.extratamientos.lista_valores_tratamiento_2,
  )
  const lista_valores_empaquetado = useSelector(
    state => state.extratamientos.lista_valores_empaquetado,
  )
  const busqueda_realizada = useSelector(state => state.buscadorExtrusion.busqueda_realizada)
  const articulo_encontrado = useSelector(state => state.experfiles.es_articulo)
  const precio = useSelector(state => state.precios.precio)
  const locale = useSelector(state => state.precios.locale)
  const moneda = useSelector(state => state.precios.moneda)
  const lista_stock = useSelector(state => state.articulo.articulo.info_stock)
  const cargando_stock = useSelector(state => state.articulo.isLoading)
  const id_pedido_seleccionado = useSelector(state => state.pedidos.id_pedido_seleccionado)
  const hash = useSelector(state => state.auth.hash)
  const usuario = useSelector(state => state.auth.user)

  const [perfil, setPerfil] = useState('')
  const [descPerfil, setDescPerfil] = useState('')
  const [pesoTeorico, setPesoTeorico] = useState('')
  const [superficieTotal, setSuperficieTotal] = useState('')
  const [aleacion, setAleacion] = useState('')
  const [longitudBarra, setLongitudBarra] = useState('')
  const [tratamiento_1_des, setTratamiento_1_des] = useState('')
  const [tratamiento_2_des, setTratamiento_2_des] = useState('')
  const [tipoEmpaquetado, setTipoEmpaquetado] = useState('')
  const [tratTermico, setTratTermico] = useState('')
  const [optionsAleacion, setOptionsAleacion] = useState(null)
  const [optionsLongitud, setOptionsLongitud] = useState(null)
  const [optionsTratamiento1, setOptionsTratamiento1] = useState(null)
  const [optionsTratamiento2, setOptionsTratamiento2] = useState(null)
  const [optionsEmpaquetado, setOptionsEmpaquetado] = useState(null)
  const [tipoPerfil, setTipoPerfil] = useState(null)
  const [cantidad, setCantidad] = useState('')
  const [mostrarPrecio, setMostrarPrecio] = useState('N')
  const [cortePrecision, setCortePrecision] = useState('')
  const [articuloFinal, setArticuloFinal] = useState('')
  const [cantidadValida, setCantidadValida] = useState('N')
  const [incluirTratamientosArt, setIncluirTratamientosArt] = useState('S')
  const [listaCortePrecision, setListaCortePrecision] = useState(null)
  //const [verTratamiento1, setVerTratamiento1] = useState(false)
  const [verTratamiento2, setVerTratamiento2] = useState(false)
  const [verEmpaquetado, setVerEmpaquetado] = useState(false)
  const [verAleacion, setVerAleacion] = useState(false)
  const [verTratamientoTermico, setVerTratamientoTermico] = useState(false)
  const [presentacionPrecioLinea, setPresentacionPrecioLinea] = useState('BAR')

  parametros = cargarParametros(parametros_usados, portal.parametros_ecom, 'ARTA')

  useEffect(() => {
    setPresentacionPrecioLinea(retrieveDefaultPresentation(portal, usuario, 'BAR', 'S'))

    return () => {
      dispatch(unsetListaEmpaquetado())
      dispatch(unsetListasTratamientos())
      dispatch(unsetTratamientos1())
      dispatch(unsetTratamientos1Completa())
      dispatch(unsetTratamientos2())
    }
  }, [])

  useEffect(() => {
    if (
      lista_tratamientos_disponibles?.length === 1 &&
      (!longitudBarra || longitudBarra === '') &&
      longitudBarra !== 0
    ) {
      handleInputChangeLongitud(lista_tratamientos_disponibles[0].longitud)
    }
  }, [lista_tratamientos_disponibles, longitudBarra])

  useEffect(() => {
    if (perfiles?.perfiles) {
      perfiles.perfiles
        .filter(perfil => perfil.codigo_perfil === perfil_seleccionado)
        .forEach(valor => {
          setPerfil(perfil_seleccionado)
          setDescPerfil(valor.desc_perfil)
          setPesoTeorico(valor.peso_teorico_por_metro)
          setSuperficieTotal(valor.superficie)
          setTipoPerfil(valor.tipo)
        })

      if (articulo_encontrado === 'S' && busqueda_realizada !== '') {
        dispatch(getTratamientosDisponibles(perfil_seleccionado, busqueda_realizada))
      } else {
        dispatch(getTratamientosDisponibles(perfil_seleccionado))
      }
    }
  }, [perfiles, articulo_encontrado, busqueda_realizada])

  useEffect(() => {
    let lista_aleacion = {}
    let lista_longitud = {}
    let valor_longitud = ''
    let lista_tratamientos_1_proc = []
    let valor_tratamiento1 = ''
    let lista_tratamientos_2_proc = []
    let lista_empaquetado = []

    if (
      articulo_encontrado === 'S' &&
      lista_tratamientos_disponibles &&
      lista_tratamientos_disponibles.length === 1 &&
      (!longitudBarra || longitudBarra === '')
    ) {
      lista_tratamientos_disponibles.map(regLongitud => {
        valor_longitud = regLongitud.longitud
        lista_longitud = {
          label: regLongitud.longitud,
          value: regLongitud.longitud,
        }

        regLongitud.siguiente_list.map(tratamiento1Listado => {
          lista_tratamientos_1_proc = {
            label: tratamiento1Listado.tipo + ' - ' + tratamiento1Listado.d_tratamiento,
            value: tratamiento1Listado.tratamiento,
            incluir_en_articulo: tratamiento1Listado.incluir_en_articulo,
            tipo_tratamiento: tratamiento1Listado.tipo,
          }

          valor_tratamiento1 = tratamiento1Listado.tratamiento

          if (tratamiento1Listado.siguiente_list.hasOwnProperty('tratamiento')) {
            tratamiento1Listado.siguiente_list.map(tratamiento2Listado => {
              lista_tratamientos_2_proc = {
                label: tratamiento2Listado.tipo + ' - ' + tratamiento2Listado.d_tratamiento,
                value: tratamiento2Listado.tratamiento,
                tipo_tratamiento: tratamiento2Listado.tipo,
              }
              /* TODO:
               * Faltaría recorrer los niveles a partir del tratamiento2 para coger el empaquetado, trattermico y aleacion
               */
            })
          } else {
            tratamiento1Listado.siguiente_list.forEach(empaquetado => {
              lista_empaquetado = {
                label: empaquetado.siguiente_list[0].d_tratamiento,
                value: empaquetado.siguiente_list[0].tratamiento,
                tipo_tratamiento: empaquetado.siguiente_list[0].tipo,
                trat_termico:
                  empaquetado.siguiente_list[0].aleacion_list[0].ttermico_list[0].tratamiento,
                aleacion: empaquetado.siguiente_list[0].aleacion_list[0].tratamiento,
              }
              lista_aleacion = {
                label:
                  empaquetado.siguiente_list[0].aleacion_list[0].tipo +
                  ' - ' +
                  empaquetado.siguiente_list[0].aleacion_list[0].d_tratamiento,
                value: empaquetado.siguiente_list[0].aleacion_list[0].tratamiento,
              }
            })
          }
        })
      })

      setLongitudBarra(valor_longitud)
      setTratamiento_1_des(lista_tratamientos_1_proc.value)
      setIncluirTratamientosArt(lista_tratamientos_1_proc.incluir_en_articulo)
      setTratamiento_2_des(
        lista_tratamientos_2_proc.value !== undefined ? lista_tratamientos_2_proc.value : '',
      )
      setTipoEmpaquetado(lista_empaquetado.value !== undefined ? lista_empaquetado.value : '')
      setAleacion(lista_empaquetado.aleacion)
      setTratTermico(lista_empaquetado.trat_termico)
      setOptionsAleacion(lista_aleacion)
      setOptionsLongitud(lista_longitud)
      setOptionsTratamiento1(lista_tratamientos_1_proc)
      setOptionsTratamiento2(lista_tratamientos_2_proc)
      setOptionsEmpaquetado(lista_empaquetado)
    }
  }, [lista_tratamientos_disponibles])

  const handleInputChangeAleacion = e => {
    setAleacion('')
    setCantidad('')
    setMostrarPrecio('N')

    if (e !== undefined && e !== '' && e != null) {
      setAleacion(e.value)
    }
  }

  const handleInputChangeLongitud = valor => {
    setLongitudBarra('')
    setTratamiento_1_des()
    setTratamiento_2_des('')
    setTipoEmpaquetado('')
    setCantidad('')
    setMostrarPrecio('N')

    dispatch(unsetTratamientos1())
    dispatch(unsetTratamientos1Completa())

    if (valor !== undefined && valor !== '' && valor != null) {
      setLongitudBarra(valor)

      let lista_tratamientos_1 = []
      let lista_tipos_aux = []

      lista_tratamientos_disponibles
        .filter(registro => registro.longitud === valor)
        .forEach(valor => {
          lista_tratamientos_1 = valor.siguiente_list
        })
      dispatch(setListaTratamientos1Completa(lista_tratamientos_1))

      lista_tratamientos_1.forEach(linea => {
        if (lista_tipos_aux.indexOf(linea.tipo) === -1) {
          return lista_tipos_aux.push(linea.tipo)
        }
      })

      dispatch(setTiposTratamiento1(lista_tipos_aux))
    }
  }

  const handleInputChangeTratamiento1 = e => {
    setTratamiento_1_des()
    setTratamiento_2_des('')
    setCortePrecision('')
    setTipoEmpaquetado('')
    setCantidad('')
    setMostrarPrecio('N')

    dispatch(unsetTratamientos2())

    if (e !== undefined && e !== '' && e != null) {
      setTratamiento_1_des(e.value)
      setIncluirTratamientosArt(e.incluir_en_articulo)

      let valores_tratamiento1 = []

      lista_tratamientos_1_completa
        .filter(reg => reg.tipo === e.tipo_tratamiento)
        .forEach(valor => {
          valores_tratamiento1.push(valor)
        })

      dispatch(setTratamientos1(valores_tratamiento1))

      const lista_tratamiento_1_seleccionado = []
      lista_tratamientos_1_completa
        .filter(n => n.tratamiento === e.value)
        .map(n => {
          return lista_tratamiento_1_seleccionado.push(n)
        })

      let lista_tratamientos_2_aux = []
      let lista_valores_tratamientos2 = []
      let lista_empaquetado = []
      let tratamiento2Visible = false
      let verEmpaquetado = false

      lista_tratamiento_1_seleccionado.map(tratamiento1 => {
        lista_tratamientos_2_aux.push(tratamiento1.siguiente_list)
        tratamiento1.siguiente_list.forEach(tratamiento2 => {
          if (tratamiento2.tratamiento !== undefined) {
            if (tratamiento2.mostrar === 'S') {
              tratamiento2Visible = true
            }
            lista_valores_tratamientos2.push(tratamiento2)
          } else {
            tratamiento2.siguiente_list.map(empaquetado => {
              if (empaquetado?.mostrar === 'S') {
                verEmpaquetado = true
              }
              lista_empaquetado.push(empaquetado)
            })
          }
        })
      })

      setVerTratamiento2(tratamiento2Visible)
      setVerEmpaquetado(verEmpaquetado)

      dispatch(setListaTratamientos2Completa(lista_tratamientos_2_aux))
      dispatch(setListaValoresTratamiento2(lista_valores_tratamientos2))
      dispatch(setListaValoresEmpaquetado(lista_empaquetado))
    }
  }

  const handleInputChangeTratamiento2 = e => {
    setTratamiento_2_des('')
    setCortePrecision('')
    setTipoEmpaquetado('')
    setCantidad('')
    setMostrarPrecio('N')
    let verEmpaquetado = false

    if (e !== undefined && e !== '' && e != null) {
      setTratamiento_2_des(e.value)
      dispatch(unsetListaEmpaquetado())

      let lista_empaquetado = []

      lista_valores_tratamiento_2
        .filter(n => n.tratamiento === e.value)
        .map((reg, index) => {
          if (reg.siguiente_list[index]?.mostrar === 'S') {
            verEmpaquetado = true
          }
          return lista_empaquetado.push(reg.siguiente_list[index])
        })
      setVerEmpaquetado(verEmpaquetado)
      dispatch(setListaValoresEmpaquetado(lista_empaquetado))
    }
  }

  const handleInputChangeEmpaquetado = e => {
    setTipoEmpaquetado('')
    setCantidad('')
    setMostrarPrecio('N')

    if (e !== undefined && e !== '' && e != null) {
      setTipoEmpaquetado(e.value)
    }

    //FALTA COMPROBAR ALEACIONES Y SETEARLAS !!!
    let lista_aleacion = []
    let lista_trat_termico = []
    let verTrarmientoTermico = false
    let verAleacion = false

    if (aleacion !== '' && aleacion !== null) {
      //Si seteamos la aleación como primer campo, ya solo nos vendr� la lista de tratamientos t�rmicos, sino iremos a buscar tambi�n la aleaci�n
      lista_valores_empaquetado
        .filter(registro => registro.tratamiento === e.value)
        .map(linea => {
          if (linea?.mostrar === 'S') {
            verTrarmientoTermico = true
          }
          return lista_trat_termico.push(linea.ttermico_list)
        })
      lista_trat_termico?.[0]?.map(t => {
        setTratTermico(t.tratamiento)
        return null
      })
      setVerTratamientoTermico(verTrarmientoTermico)
    } else {
      lista_valores_empaquetado
        .filter(registro => registro.tratamiento === e.value)[0]
        .aleacion_list.map(opcion_aleacion => {
          if (typeof opcion_aleacion === 'object') {
            if (opcion_aleacion?.mostrar === 'S') {
              verAleacion = true
            }
            return lista_aleacion.push(opcion_aleacion)
          }
        })

      setVerAleacion(verAleacion)
      setOptionsAleacion(lista_aleacion)

      // Cogemos el primer valor entre las aleaciones y tratamientos termicos que nos vengan en la lista
      lista_aleacion.map(a => {
        setAleacion(a.tratamiento)
        return lista_trat_termico.push(a.ttermico_list)
      })

      lista_trat_termico?.[0]?.map(t => {
        setTratTermico(t.tratamiento)
        return null
      })
    }
  }

  const verPrecio = e => {
    e.preventDefault()

    setMostrarPrecio('S')
    setArticuloFinal(articuloFinal)
  }

  const onBlur = e => {
    if (e.target.name === 'cantidad') {
      if (cantidad && perfiles.perfiles[0].barras_caja) {
        if (cantidad % perfiles.perfiles[0].barras_caja !== 0) {
          setCantidadValida('N')
          confirmAlert({
            title: i18n.t('articulos_extrusion.titmulcaj'),
            message: i18n.t('articulos_extrusion.msgmulcaj') + perfiles.perfiles[0].barras_caja,
            closeOnEscape: true,
            closeOnClickOutside: true,
            buttons: [
              {
                label: i18n.t('general.aceptar'),
              },
            ],
          })
        }
      }
    }
  }

  const onChange = e => {
    let lista_empaquetado_procesada = []
    let lista_valores = []
    let valores_tratamiento1 = []
    let lista_valores_tratamiento2 = []
    let lista_tratamientos_2_completa = []
    let lista_tipos_tratamiento2 = []
    let lista_aleacion = []
    let lista_trat_termico = []

    switch (e.target.name) {
      case 'longitud_barra':
        setLongitudBarra(e.value)
        dispatch(unsetTratamientos1())
        dispatch(unsetTratamientos1Completa())

        if (e.target.value !== undefined && e.target.value !== '') {
          let lista_tratamientos_1 = []
          let lista_tipos_aux = []
          lista_tratamientos_disponibles
            .filter(registro => registro.longitud === e.target.value)
            .forEach(valor => {
              lista_tratamientos_1 = valor.siguiente_list
            })
          dispatch(setListaTratamientos1Completa(lista_tratamientos_1))

          lista_tratamientos_1.forEach(linea => {
            if (lista_tipos_aux.indexOf(linea.tipo) === -1) {
              return lista_tipos_aux.push(linea.tipo)
            }
          })

          dispatch(setTiposTratamiento1(lista_tipos_aux))
        }

        setTratamiento_1_des('')
        setTratamiento_2_des('')
        setCortePrecision('')
        setTipoEmpaquetado('')
        setCantidad('')
        setMostrarPrecio('N')
        break
      case 'tratamiento_1':
        dispatch(unsetTratamientos2())
        setTratamiento_1_des('')
        setTratamiento_2_des('')
        setCortePrecision('')
        setTipoEmpaquetado('')
        setCantidad('')
        setMostrarPrecio('N')

        lista_tratamientos_1_completa
          .filter(reg => reg.tipo === e.target.value)
          .forEach(valor => {
            valores_tratamiento1.push(valor)
          })

        setTratamientos1(valores_tratamiento1)
        break
      case 'tratamiento_1_des':
        setTratamiento_1_des(e.value)
        dispatch(unsetTratamientos2())

        setTratamiento_2_des('')
        setCortePrecision('')
        setTipoEmpaquetado('')
        setCantidad('')
        setMostrarPrecio('N')

        lista_tratamientos_1
          .filter(n => n.tratamiento === e.target.value)
          .map(reg => {
            setIncluirTratamientosArt(reg.incluir_en_articulo)
          })

        lista_tratamientos_1
          .filter(registro => registro.tratamiento === e.target.value)
          .forEach(resultado => {
            lista_tratamientos_2_completa.push(resultado.siguiente_list)
          })

        dispatch(
          setListaTratamientos2Completa(
            lista_tratamientos_1.filter(registro => registro.tratamiento === e.target.value),
          ),
        )

        lista_tratamientos_2_completa.map((linea, index) => {
          if (linea[index].tipo !== undefined || linea[index].tipo !== '')
            lista_tipos_tratamiento2.push(linea[index].tipo)
        })

        lista_tratamientos_2_completa[0].forEach(registro => {
          lista_empaquetado_procesada.push(registro.siguiente_list)
        })

        if (lista_empaquetado_procesada && lista_empaquetado_procesada.length > 0) {
          dispatch(setListaValoresEmpaquetado(lista_empaquetado_procesada))
        }

        if (lista_tratamientos_2_completa && lista_tratamientos_2_completa.length > 0) {
          dispatch(setListaTratamientos2(lista_tratamientos_2_completa))
          lista_tratamientos_2_completa.forEach(linea => {
            if (lista_tipos_tratamiento2.indexOf(linea.tipo) === -1) {
              return lista_tipos_tratamiento2.push(linea.tipo)
            }
          })

          dispatch(setListaTiposTratamiento2(lista_tipos_tratamiento2))
          if (lista_tipos_tratamiento2[0] === undefined) {
            // Puede que el perfil no tenga tratamiento 2 (segundo nivel) pero s� empaquetado (tercer nivel)
            dispatch(setListaValoresEmpaquetado(lista_tratamientos_2_completa[0][0].siguiente_list))
          }
        }
        break
      case 'tratamiento_2':
        setTratamiento_2_des('')
        setCortePrecision('')
        setTipoEmpaquetado('')
        setCantidad('')
        setMostrarPrecio('N')

        lista_tratamientos_2.map(registro => {
          registro
            .filter(linea => linea.tipo === e.target.value)
            .forEach(valor => {
              lista_valores_tratamiento2.push(valor)
            })
        })

        dispatch(setListaValoresTratamiento2(lista_valores_tratamiento2))
        break
      case 'tratamiento_2_des':
        setTratamiento_2_des(e.value)
        setCortePrecision('')
        setTipoEmpaquetado('')
        setCantidad('')
        setMostrarPrecio('N')

        lista_tratamientos_2[0]
          .filter(registro => registro.tratamiento === e.target.value)
          .forEach(valor => {
            return lista_empaquetado_procesada.push(valor.siguiente_list)
          })

        if (lista_empaquetado_procesada && lista_empaquetado_procesada.length > 0) {
          lista_empaquetado_procesada[0].map((empaquetado, index) => {
            return lista_valores.push(empaquetado)
          })

          dispatch(setListaValoresEmpaquetado(lista_valores))
        }
        break
      case 'tipo_empaquetado':
        setTipoEmpaquetado(e.value)
        setCantidad('')
        setMostrarPrecio('N')

        lista_valores_empaquetado
          .filter(registro => registro.tratamiento === e.target.value)
          .map(linea => {
            lista_aleacion.push(linea.aleacion_list)
          })

        // Cogemos el primer valor entre las aleaciones y tratamientos termicos que nos vengan en la lista
        lista_aleacion[0].map(a => {
          setAleacion(a.tratamiento)
          lista_trat_termico.push(a.ttermico_list)
        })
        lista_trat_termico[0].map(t => {
          setTratTermico(t.tratamiento)
        })
        break
      case 'cantidad':
        setCantidad(e.target.value)
        setMostrarPrecio('N')
        if (e.target.value !== null && e.target.value !== '') {
          if (
            perfiles.perfiles[0].barras_caja !== null &&
            e.target.value % perfiles.perfiles[0].barras_caja !== 0
          ) {
            setCantidadValida('N')
          } else {
            let articulo = construirArticulo()

            setCantidadValida('S')

            if (e.target.value !== '') {
              dispatch(getPrecio(articulo, e.target.value, '', '', presentacionPrecioLinea))
            }

            dispatch(getStockArtAlu(articulo, presentacionPrecioLinea, '', 'S', ''))
          }
        }
        break
      default:
        console.log('No se reconoce el nombre del evento. FormularioExtrusion.onChange')
        break
    }
  }

  const construirArticulo = () => {
    let longitud = ''

    if (longitudBarra && longitudBarra.toString().length > 4) {
      // Si la medida supera los 4 dígitos utilizamos fórmula estandar de conversión del aluminio
      let subcadena = String.fromCharCode(
        parseInt(longitudBarra.toString().substring(0, longitudBarra.toString().length - 3)) + 55,
      )
      let subcadena2 = longitudBarra.toString().substring(longitudBarra.toString().length - 3)

      longitud = subcadena + subcadena2
    } else {
      longitud = String(longitudBarra)

      // Mientras la longitud del string sea menor que 4, añadir '0' a la izquierda
      while (longitud.length < 4) {
        longitud = '0' + longitud
      }
    }

    let articulo = null
    /* Contruimos el nombre del articulo en función del tipo */
    switch (tipoPerfil) {
      case 'C':
        articulo = perfil + (tratTermico || '')
        break
      case 'R':
        articulo = perfil + 'X' + longitud + (tratTermico || '')
        break
      default:
        articulo = perfil + aleacion + 'X' + longitud + (tratTermico || '')
    }

    /* Si el tipo tratamiento es Mill Finish, no se agregan al art�culo los tratamientos */
    if (incluirTratamientosArt === 'S') articulo += tratamiento_1_des + tratamiento_2_des

    if (cortePrecision !== undefined && cortePrecision !== '') {
      articulo += 'C' + cortePrecision
    }

    articulo += tipoEmpaquetado

    setArticuloFinal(articulo)

    return articulo
  }

  const anadirCarro = e => {
    e.preventDefault()

    const articulo = construirArticulo()
    // Obtenemos los datos del perfil
    let datos_perfil = perfiles.perfiles.find(
      perfil => perfil.codigo_perfil === perfil_seleccionado,
    )
    // Comprobamos si es una chapa
    let pres_aux =
      datos_perfil?.tipo === 'C'
        ? precio?.[articulo]?.[presentacionPrecioLinea]?.presentacion_precio
        : presentacionPrecioLinea

    let linea = {
      articulo: articulo,
      perfil: perfil,
      longitud: longitudBarra,
      descripcion: descPerfil,
      precio_venta: 0,
      observaciones: '',
      estado_linea: 'B',
      cantidad_pedida: cantidad,
      presentacion_pedido: pres_aux,
      tipo_linea: 'P',
      sub_pres: '',
      sub_pres_cant: '',
      sub_pres_fc: '',
      presentacion_escogida: '',
      pres_fc: '',
    }

    dispatch(postLinea(linea, hash, id_pedido_seleccionado))

    dispatch(unsetExGrupoSeleccionado())
    dispatch(unsetExSerieSeleccionada())
    dispatch(unsetExSubSerieSeleccionada())
    dispatch(unsetPerfilSeleccionado())
    dispatch(unsetBusquedaExtrusion())

    if (portal.ex_agrupacion_perfiles === 'GSBP' || portal.ex_agrupacion_perfiles === 'GSP') {
      dispatch(getMasGrupos())
    } else if (portal.ex_agrupacion_perfiles === 'SP') {
      dispatch(getMasSeries())
    } else if (portal.ex_agrupacion_perfiles === 'P') {
      dispatch(getMasPerfiles())
    }
  }

  const onSubmit = e => {
    e.preventDefault()
    if (cantidad !== '' && cantidad < perfiles.perfiles[0].num_barras_min_pedido) {
      confirmAlert({
        title: i18n.t('articulos_extrusion.titcanmin'),
        message: i18n.t('articulos_extrusion.msgcanmin'),
        closeOnEscape: true,
        closeOnClickOutside: true,
        buttons: [
          {
            label: i18n.t('general.si'),
            onClick: () => introducirLinea(e),
          },
          {
            label: i18n.t('general.no'),
          },
        ],
      })
    } else {
      introducirLinea(e)
    }
  }

  const introducirLinea = e => {
    anadirCarro(e)
    if (articulo_encontrado === 'S') {
      setCantidad('')
    }
  }

  const getOptionsLongitudes = () => {
    if (articulo_encontrado === 'S' && optionsLongitud !== null) {
      return {
        label: optionsLongitud.label,
        value: optionsLongitud.value,
      }
    } else if (lista_longitudes !== undefined) {
      return lista_longitudes.map(longitud => {
        return {
          value: longitud !== undefined ? longitud : '',
          label: longitud !== undefined ? longitud : '',
        }
      })
    } else return null
  }

  const getValueLongitudes = () => {
    if (articulo_encontrado === 'S' && optionsLongitud !== null) {
      return {
        label: optionsLongitud.label,
        value: optionsLongitud.value,
      }
    } else if (lista_longitudes?.length > 0) {
      if (lista_longitudes.length === 1) {
        return {
          value: lista_longitudes[0],
          label: lista_longitudes[0],
        }
      } else {
        return lista_longitudes.map(longitud => {
          if (longitud === longitudBarra)
            return {
              value: longitud,
              label: longitud,
            }
        })
      }
    } else return null
  }

  const getOptionsTratamiento1 = () => {
    if (articulo_encontrado === 'S' && optionsTratamiento1 !== null) {
      return {
        label: optionsTratamiento1.label,
        value: optionsTratamiento1.value,
        incluir_en_articulo: optionsTratamiento1.incluir_en_articulo,
        tipo_tratamiento: optionsTratamiento1.tipo_tratamiento,
      }
    } else if (lista_tratamientos_1_completa?.length > 0) {
      return lista_tratamientos_1_completa.map(tratamiento => {
        return {
          label: tratamiento.tipo + ' - ' + tratamiento.d_tratamiento,
          value: tratamiento.tratamiento,
          incluir_en_articulo: tratamiento.incluir_en_articulo,
          tipo_tratamiento: tratamiento.tipo,
        }
      })
    } else return ''
  }

  const getValueTratamiento1 = () => {
    if (articulo_encontrado === 'S' && optionsTratamiento1 !== null) {
      return {
        label: optionsTratamiento1.label,
        value: optionsTratamiento1.value,
        incluir_en_articulo: optionsTratamiento1.incluir_en_articulo,
        tipo_tratamiento: optionsTratamiento1.tipo_tratamiento,
      }
    } else if (lista_tratamientos_1_completa?.length > 0) {
      return lista_tratamientos_1_completa.map(tratamiento => {
        if (tratamiento.tratamiento === tratamiento_1_des) {
          return {
            label: tratamiento.tipo + ' - ' + tratamiento.d_tratamiento,
            value: tratamiento.tratamiento,
            incluir_en_articulo: tratamiento.incluir_en_articulo,
            tipo_tratamiento: tratamiento.tipo,
          }
        }
      })
    } else return ''
  }

  const getOptionsTratamiento2 = () => {
    if (articulo_encontrado === 'S' && optionsTratamiento2 !== null) {
      return {
        label: optionsTratamiento2.label,
        value: optionsTratamiento2.value,
        tipo_tratamiento: optionsTratamiento2.tipo_tratamiento,
      }
    } else if (lista_valores_tratamiento_2?.length > 0) {
      return lista_valores_tratamiento_2.map(tratamiento => {
        return {
          label: tratamiento.tipo + ' - ' + tratamiento.d_tratamiento,
          value: tratamiento.tratamiento,
          incluir_en_articulo: tratamiento.incluir_en_articulo,
          tipo_tratamiento: tratamiento.tipo,
        }
      })
    } else return null
  }

  const getValueTratamiento2 = () => {
    if (articulo_encontrado === 'S' && optionsTratamiento2 !== null) {
      return {
        label: optionsTratamiento2.label,
        value: optionsTratamiento2.value,
        tipo_tratamiento: optionsTratamiento2.tipo_tratamiento,
      }
    } else if (tratamiento_2_des !== '' && lista_valores_tratamiento_2?.length > 0) {
      return lista_valores_tratamiento_2.map(tratamiento => {
        if (tratamiento.tratamiento === tratamiento_2_des) {
          return {
            label: tratamiento.tipo + ' - ' + tratamiento.d_tratamiento,
            value: tratamiento.tratamiento,
            incluir_en_articulo: tratamiento.incluir_en_articulo,
            tipo_tratamiento: tratamiento.tipo,
          }
        }
      })
    } else return null
  }

  const getOptionsTipoEmpaquetado = () => {
    if (articulo_encontrado === 'S' && optionsEmpaquetado !== null) {
      return {
        label: optionsEmpaquetado.label,
        value: optionsEmpaquetado.value,
        tipo_tratamiento: optionsEmpaquetado.tipo_tratamiento,
      }
    } else
      return lista_valores_empaquetado.map(empaquetado => {
        return {
          label: empaquetado.d_tratamiento,
          value: empaquetado.tratamiento,
          tipo_tratamiento: empaquetado.tipo,
        }
      })
  }

  const getValueTipoEmpaquetado = () => {
    if (articulo_encontrado === 'S' && optionsEmpaquetado !== null) {
      return {
        label: optionsEmpaquetado.label,
        value: optionsEmpaquetado.value,
        tipo_tratamiento: optionsEmpaquetado.tipo_tratamiento,
      }
    } else
      return lista_valores_empaquetado.map(empaquetado => {
        if (empaquetado.tratamiento === tipoEmpaquetado)
          return {
            label: empaquetado.tipo + ' - ' + empaquetado.d_tratamiento,
            value: empaquetado.tratamiento,
            tipo_tratamiento: empaquetado.tipo,
          }
      })
  }

  const getOptionsAleacion = () => {
    if (articulo_encontrado === 'S' && optionsAleacion && optionsAleacion !== null) {
      return {
        label: optionsAleacion.label,
        value: optionsAleacion.value,
      }
    } else if (optionsAleacion && optionsAleacion.length > 0) {
      return optionsAleacion.map(aleacion => {
        return {
          label: aleacion.tipo + ' - ' + aleacion.d_tratamiento,
          value: aleacion.tratamiento,
        }
      })
    } else return ''
  }

  const getValueAleacion = () => {
    if (articulo_encontrado === 'S' && optionsAleacion !== null) {
      return {
        label: optionsAleacion.label,
        value: optionsAleacion.value,
      }
    } else if (optionsAleacion?.length > 0) {
      return optionsAleacion.map(regAleacion => {
        if (regAleacion.tratamiento === aleacion)
          return {
            label: regAleacion.tipo + ' - ' + regAleacion.d_tratamiento,
            value: regAleacion.tratamiento,
          }
      })
    } else return ''
  }

  const validKeyForQuantity = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'Backspace']

  if (recuperando_datos) {
    return <Spinner showSpinner={true} />
  } else {
    return (
      <div
        id='tt-formulario-extrusion'
        className='tt-formulario-extrusion'>
        <div className='container-indent'>
          <div className='container'>
            <div className='tt-login-form'>
              <div className='row-formulario'>
                <div className='col'>
                  <div className='tt-item tt-item-formulario'>
                    <div className='form-default justify-content-center'>
                      <form onSubmit={onSubmit}>
                        <div className='row-formulario'>
                          <div className='col'>
                            <div className='form-group'>
                              <label
                                htmlFor='input_perfil'
                                className='inline-label'>
                                {i18n.t('articulos_extrusion.perfil')}
                              </label>
                              <input
                                className='form-control inline-input'
                                type='text'
                                name='perfil'
                                id='input_perfil'
                                value={perfil}
                                disabled='disabled'></input>
                            </div>
                            {parametros.mostrar_peso_teorico === 'S' ? (
                              <div className='form-group'>
                                <label
                                  htmlFor='input_peso_teorico'
                                  className='inline-label'>
                                  {i18n.t('articulos_extrusion.lblpesteo')}
                                </label>
                                <input
                                  className='form-control inline-input'
                                  type='text'
                                  name='peso_teorico'
                                  id='input_peso_teorico'
                                  value={pesoTeorico}
                                  disabled='disabled'
                                />
                              </div>
                            ) : (
                              ''
                            )}
                            {parametros.mostrar_superficie_total === 'S' ? (
                              <div className='form-group'>
                                <label
                                  htmlFor='input_superficie_total'
                                  className='inline-label'>
                                  {i18n.t('articulos_extrusion.lblsuptot')}
                                </label>
                                <input
                                  className='form-control inline-input'
                                  type='text'
                                  name='superficie_total'
                                  id='input_superficie_total'
                                  value={superficieTotal}
                                  disabled='disabled'
                                />
                              </div>
                            ) : (
                              ''
                            )}
                            <div
                              className={'form-group'}
                              style={tipoPerfil === 'C' ? { display: 'none' } : null}>
                              <label
                                id='longitud-label'
                                htmlFor='logitud_barra-input'>
                                {i18n.t('articulos_extrusion.seleclong')}
                              </label>
                              <Select
                                aria-labelledby='longitud-label'
                                inputId='logitud_barra-input'
                                className='basic-single'
                                classNamePrefix='select'
                                name='longitud_barra'
                                placeholder='Escoja la longitud deseada'
                                onChange={e => {
                                  handleInputChangeLongitud(e.value)
                                }}
                                isSearchable={articulo_encontrado !== 'S'}
                                isClearable={articulo_encontrado !== 'S'}
                                isDisabled={articulo_encontrado === 'S'}
                                options={getOptionsLongitudes()}
                                value={getValueLongitudes()}
                              />
                            </div>
                            <div
                              className='form-group'
                              style={
                                longitudBarra !== undefined && longitudBarra === ''
                                  ? { display: 'none' }
                                  : null
                              }>
                              <label
                                id='tratamiento_1-label'
                                htmlFor='input_tratamiento_1'>
                                {i18n.t('articulos_extrusion.lbltrat1')}
                              </label>
                              <Select
                                inputId='input_tratamiento_1'
                                isSearchable={articulo_encontrado !== 'S'}
                                isClearable={articulo_encontrado !== 'S'}
                                isDisabled={articulo_encontrado === 'S'}
                                options={getOptionsTratamiento1()}
                                onChange={handleInputChangeTratamiento1}
                                value={getValueTratamiento1()}
                              />
                            </div>
                            {tratamiento_1_des === undefined ||
                            tratamiento_1_des === null ||
                            tratamiento_1_des === '' ||
                            (lista_valores_tratamiento_2 &&
                              lista_valores_tratamiento_2.length === 0) ? (
                              ''
                            ) : (
                              <div
                                className='form-group'
                                style={!verTratamiento2 ? { display: 'none' } : null}>
                                <label
                                  id='tratamiento_2-label'
                                  htmlFor='input_tratamiento_2'>
                                  {i18n.t('articulos_extrusion.lbltrat2')}
                                </label>
                                <Select
                                  inputId='input_tratamiento_2'
                                  isSearchable={articulo_encontrado !== 'S'}
                                  isClearable={articulo_encontrado !== 'S'}
                                  isDisabled={articulo_encontrado === 'S'}
                                  onChange={handleInputChangeTratamiento2}
                                  options={getOptionsTratamiento2()}
                                  value={getValueTratamiento2()}
                                />
                              </div>
                            )}
                            {!listaCortePrecision ||
                            (listaCortePrecision && listaCortePrecision.length === 0) ? (
                              ''
                            ) : (
                              <div
                                className={'form-group'}
                                style={
                                  longitudBarra !== undefined && longitudBarra === ''
                                    ? { display: 'none' }
                                    : null
                                }>
                                <label
                                  htmlFor='input_corte_precision'
                                  className='inline-label'>
                                  {i18n.t('articulos_extrusion.lblcorpre')}
                                </label>
                                <input
                                  className='form-control inline-input'
                                  type='number'
                                  name='corte_precision'
                                  id='input_corte_precision'
                                  onChange={onChange}
                                  value={cortePrecision}
                                  placeholder='Corte precisión'
                                />
                              </div>
                            )}
                            {tratamiento_1_des === undefined ||
                            tratamiento_1_des === '' ||
                            tratamiento_1_des === null ? (
                              ''
                            ) : (
                              <div
                                className='form-group'
                                style={!verEmpaquetado ? { display: 'none' } : null}>
                                <label
                                  id='tipo_empaquetado-label'
                                  htmlFor='input_tipo_empaquetado'>
                                  {i18n.t('articulos_extrusion.lbltipemp')}
                                </label>
                                <Select
                                  inputId='input_tipo_empaquetado'
                                  isSearchable={articulo_encontrado !== 'S'}
                                  isClearable={articulo_encontrado !== 'S'}
                                  isDisabled={articulo_encontrado === 'S'}
                                  onChange={handleInputChangeEmpaquetado}
                                  options={getOptionsTipoEmpaquetado()}
                                  value={getValueTipoEmpaquetado()}
                                />
                              </div>
                            )}
                            {!tipoEmpaquetado || tipoEmpaquetado === '' ? (
                              ''
                            ) : (
                              <div
                                className={'form-group'}
                                style={
                                  tipoPerfil === 'C' ||
                                  tipoPerfil === 'R' ||
                                  (!verAleacion && !verTratamientoTermico)
                                    ? { display: 'none' }
                                    : null
                                }>
                                <label
                                  id='aleacion-label'
                                  htmlFor='aleacion-input'>
                                  {i18n.t('articulos_extrusion.selaleac')}
                                </label>
                                <Select
                                  aria-labelledby='aleacion-label'
                                  inputId='aleacion-input'
                                  className='basic-single'
                                  classNamePrefix='select'
                                  name='aleacion'
                                  placeholder={i18n.t('articulos_extrusion.escoaleac')}
                                  onChange={handleInputChangeAleacion}
                                  isSearchable={articulo_encontrado !== 'S'}
                                  isClearable={articulo_encontrado !== 'S'}
                                  isDisabled={articulo_encontrado === 'S'}
                                  options={getOptionsAleacion()}
                                  value={getValueAleacion()}
                                />
                              </div>
                            )}
                            <div
                              className={'form-group form-group-cantidad'}
                              style={
                                longitudBarra !== undefined && longitudBarra === ''
                                  ? { display: 'none' }
                                  : { display: 'inline-flex' }
                              }>
                              <label
                                htmlFor='input_cantidad'
                                className='inline-label'>
                                {i18n.t('articulos_extrusion.cantidad') +
                                  ' (' +
                                  i18n.t('articulos_extrusion.piezas') +
                                  ')'}
                              </label>
                              <div
                                style={{
                                  display: 'inline-flex',
                                  maxWidth: '80%',
                                  minWidth: '80%',
                                  gap: '10px',
                                  alignItems: 'center',
                                }}>
                                <input
                                  className='form-control inline-input'
                                  type='number'
                                  name='cantidad'
                                  id='input_cantidad'
                                  onChange={onChange}
                                  onBlur={onBlur}
                                  value={cantidad}
                                  placeholder='Cantidad'
                                  onKeyDown={e => {
                                    if (!validKeyForQuantity.includes(e.key)) {
                                      e.preventDefault()
                                    }
                                  }}
                                />
                                <button
                                  className='btn btn-secondary'
                                  style={
                                    cantidad !== undefined && cantidad > 0
                                      ? { marginRight: 'auto' }
                                      : {
                                          background: 'gray',
                                          marginRight: 'auto',
                                        }
                                  }
                                  disabled={
                                    cantidad !== undefined && cantidad > 0 ? '' : 'disabled'
                                  }
                                  onClick={verPrecio}>
                                  {i18n.t('articulos_extrusion.verprecio')}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </form>
                      {cargando_stock ? (
                        <Spinner />
                      ) : tipoEmpaquetado && lista_stock?.datos_stock?.length > 0 ? (
                        <TablaStock datosStock={lista_stock.datos_stock} />
                      ) : (
                        ''
                      )}
                      <form
                        onSubmit={onSubmit}
                        className='form-inline form-default anadir-carrito-extrusion'>
                        <button
                          type='submit'
                          className='btn btn-primary'
                          style={
                            cantidad !== undefined &&
                            cantidad > 0 &&
                            tratamiento_1_des !== '' &&
                            cantidadValida === 'S'
                              ? {}
                              : { background: 'gray' }
                          }
                          disabled={
                            cantidad !== undefined &&
                            cantidad > 0 &&
                            tratamiento_1_des !== '' &&
                            cantidadValida === 'S'
                              ? ''
                              : 'disabled'
                          }>
                          <FontAwesomeIcon
                            icon={faCartPlus}
                            className='mr-2'
                          />
                          {i18n.t('articulos_extrusion.btnanadir').toUpperCase()}
                        </button>
                        {mostrarPrecio === 'S' &&
                        articuloFinal !== '' &&
                        precio[articuloFinal][presentacionPrecioLinea] !== undefined &&
                        precio[articuloFinal][presentacionPrecioLinea].status !== 'error' &&
                        precio[articuloFinal][presentacionPrecioLinea].status !== 'fetching' &&
                        precio[articuloFinal][presentacionPrecioLinea].precio_presentacion !==
                          undefined ? (
                          <Grid container>
                            <Grid
                              item
                              xs={12}
                              sm={12}
                              md={8}
                              lg={6}
                              xl={6}
                              style={{ display: 'inline-flex' }}>
                              <div className='tt-quantity'>
                                {cantidad +
                                  ' (' +
                                  precio[articuloFinal][presentacionPrecioLinea].presentacion +
                                  ') X '}
                              </div>
                              <div className='tt-price'>
                                <Precio
                                  codigo_articulo={articuloFinal}
                                  mostrar_iva={parametros.mostrar_iva}
                                  presentacion={presentacionPrecioLinea}
                                />
                              </div>
                            </Grid>
                            <Grid
                              item
                              xs={12}
                              sm={12}
                              md={12}
                              lg={12}
                              xl={6}>
                              TOTAL:{' '}
                              {Intl.NumberFormat(locale, {
                                style: 'currency',
                                currency: moneda,
                              }).format(
                                Number.parseFloat(
                                  (
                                    precio?.[articuloFinal]?.[presentacionPrecioLinea]
                                      ?.importe_bruto || 0
                                  )
                                    .toString()
                                    .replace(/,/g, '.'),
                                ).toFixed(4),
                              )}
                            </Grid>
                            {tipoPerfil !== 'C' && (
                              <Grid
                                item
                                xs={12}
                                sm={12}
                                md={12}
                                lg={12}
                                xl={6}
                                className='tt-quantity'>
                                {Intl.NumberFormat().format(
                                  Number.parseFloat(cantidad * (longitudBarra / 1000)).toFixed(2),
                                ) + ' MTS'}
                              </Grid>
                            )}
                          </Grid>
                        ) : (
                          ''
                        )}
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default FormularioExtrusion
